import type { FC } from 'react';
import { Suspense, useMemo } from 'react';

import { SectionContainer } from '../../../../components/section-container/section-container';
import { SimpleCompanyCardGrid } from '../../../../components/simple-company-card-grid/simple-company-card-grid';
import { useMostVisitedCompanies } from '../../../../hooks/use-most-visited-companies';
import { createSimpleCompanies } from '../../../../models/simple-company';
import { ROUTES } from '../../../../routes';

const LIMIT = 6;

type MostVisitedCompaniesSectionProps = {
  trackingPage: string;
};

const MostVisitedCompaniesSectionInner: FC<
  MostVisitedCompaniesSectionProps
> = ({ trackingPage }) => {
  const { data } = useMostVisitedCompanies({
    limit: LIMIT,
  });

  const mostVisitedCompanies = data?.mostVisitedCompanies?.collection ?? [];
  const simpleCompanyCards = useMemo(
    // @ts-expect-error ignore null errors from graphql
    () => createSimpleCompanies(mostVisitedCompanies),
    [mostVisitedCompanies]
  );

  return (
    <SimpleCompanyCardGrid
      items={simpleCompanyCards}
      trackingPage={trackingPage}
    />
  );
};

export const MostVisitedCompaniesSection: FC<
  MostVisitedCompaniesSectionProps
> = ({ trackingPage }) => {
  return (
    <SectionContainer
      title="CP_MOST_VISITED_COMPANIES_TITLE"
      subtitle="CP_MOST_VISITED_COMPANIES_SUBLINE"
      linkUri={ROUTES.mostVisitedCompanies}
    >
      <Suspense fallback={null}>
        <MostVisitedCompaniesSectionInner trackingPage={trackingPage} />
      </Suspense>
    </SectionContainer>
  );
};
